/* REGNA by LINTEL PDP: gallery (dots/thumbs, colour filter), colour swatches -> variant id, before/after slider, open brand cart drawer after any add */
(function () {
  var tr = document.querySelector('[data-rg-track]'), dots = document.querySelector('[data-rg-dots]'), thumbs = document.querySelector('[data-rg-thumbs]');
  function vis() { return tr ? Array.prototype.filter.call(tr.children, function (e) { return !e.hidden; }) : []; }
  function drawDots() {
    if (!tr || !dots) return;
    var n = vis().length; dots.innerHTML = Array(n + 1).join('<span></span>');
    dots.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }); });
    upd();
  }
  function upd() {
    if (!tr || !dots) return;
    var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    dots.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (thumbs) { var v = vis(); thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', v[i] && b.dataset.i === v[i].dataset.i); }); }
  }
  if (tr) {
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { var v = vis(); for (var k = 0; k < v.length; k++) if (v[k].dataset.i === b.dataset.i) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); });
    });
    drawDots();
  }
  /* colour swatches: set the variant id, show that colour's photos first (alt prefix "Black — " / "Grey — ") */
  var sw = document.querySelectorAll('[data-rg-sw] input');
  function pick(inp) {
    var id = document.querySelector('form[data-rg-add] input[name=id]'); if (id) id.value = inp.value;
    var lab = document.querySelector('[data-rg-colour]'); if (lab) lab.textContent = inp.dataset.name;
    if (tr) {
      var col = inp.dataset.name.toLowerCase();
      Array.prototype.forEach.call(tr.children, function (img) { var a = (img.alt || '').toLowerCase(); img.hidden = !(a.indexOf(col + ' ') === 0); });
      if (!vis().length) Array.prototype.forEach.call(tr.children, function (img) { img.hidden = false; });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) { var img = tr.querySelector('[data-i="' + b.dataset.i + '"]'); b.hidden = img ? img.hidden : false; });
      tr.scrollTo({ left: 0 }); drawDots();
    }
    try { var u = new URL(location.href); u.searchParams.set('variant', inp.value); history.replaceState(null, '', u); } catch (e) {}
  }
  sw.forEach(function (inp) { inp.addEventListener('change', function () { pick(inp); }); if (inp.checked) pick(inp); });
  /* before / after */
  document.querySelectorAll('[data-rg-ba]').forEach(function (ba) {
    var r = ba.querySelector('input'), a = ba.querySelector('.rg-ba__after'), h = ba.querySelector('.rg-ba__h');
    r.addEventListener('input', function () { a.style.clipPath = 'inset(0 0 0 ' + r.value + '%)'; h.style.left = r.value + '%'; });
  });
  /* brand cart drawer after any add (Kaching or native) */
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.RG) window.RG.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
})();
/* REGNA: review carousel */
(function () {
  document.querySelectorAll('[data-rg-cq]').forEach(function (c) {
    var tr = c.querySelector('.rg-cq__track');
    c.querySelectorAll('.rg-cq__nav button').forEach(function (b) {
      b.addEventListener('click', function () { tr.scrollBy({ left: +b.dataset.d * tr.clientWidth, behavior: 'smooth' }); });
    });
  });
  var s = document.querySelector('[data-rg-shades]');
  if (s) s.addEventListener('click', function () { var d = document.getElementById('rg-shades'); if (d) d.open = true; });
})();


/* REGNA pack picker: 1 / Buy 2 get 1 (3) / Buy 3 get 2 (5), a colour per umbrella -> /cart/add.js items[] (real units) */
(function () {
  var form = document.querySelector('form[data-rg-add]'); if (!form) return;
  var vj = document.querySelector('[data-rg-variants]'), V = vj ? JSON.parse(vj.textContent) : [];
  var HEX = {'Black':'#1E1F22','Beige':'#E6DCC8','Green':'#2F4A38','Grey':'#B5B8BB','Navy':'#25325E','Pink':'#EBC3C3','Sky Blue':'#A9C4E2','Wine Red':'#6E2233'};
  var track = document.querySelector('[data-rg-track]');
  function showColour(c) {
    if (!track) return;
    var imgs = track.querySelectorAll('img');
    for (var k = 0; k < imgs.length; k++) if ((imgs[k].alt || '').indexOf(c + ' ') === 0) { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); return; }
  }
  var sel = {};
  document.querySelectorAll('.rg-pk').forEach(function (pk) {
    var n = +pk.dataset.n, box = pk.querySelector('[data-rg-cols]'); sel[n] = [];
    for (var u = 0; u < n; u++) {
      sel[n].push(V[0] ? V[0].c : '');
      var row = document.createElement('div'); row.className = 'rg-crow';
      row.innerHTML = '<small>#' + (u + 1) + '</small>' + V.map(function (x) {
        return '<button type="button" class="rg-dot' + (x.c === sel[n][u] ? ' is-on' : '') + '" data-u="' + u + '" data-c="' + x.c + '" title="' + x.c + '" aria-label="' + x.c + '" style="background:' + (HEX[x.c] || '#ccc') + '"' + (x.a ? '' : ' disabled') + '></button>';
      }).join('') + '<span class="rg-cname" data-cn>' + sel[n][u] + '</span>';
      box.appendChild(row);
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.rg-dot'); if (!b) return; e.preventDefault(); e.stopPropagation();
      var u = +b.dataset.u; sel[n][u] = b.dataset.c;
      var row = b.parentNode; row.querySelectorAll('.rg-dot').forEach(function (d) { d.classList.toggle('is-on', d === b); });
      row.querySelector('[data-cn]').textContent = b.dataset.c; showColour(b.dataset.c);
    });
  });
  var cur = 3;
  document.querySelectorAll('.rg-pk input').forEach(function (r) {
    if (r.checked) cur = +r.value;
    r.addEventListener('change', function () {
      cur = +r.value;
      document.querySelectorAll('.rg-pk').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
      var q = form.querySelector('[data-rg-qty]'); if (q) q.value = cur;
    });
  });
  var q0 = form.querySelector('[data-rg-qty]'); if (q0) q0.value = cur;
  window.RGPACK = { sel: sel, cur: function () { return cur; } };
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); btn.disabled = true;
    var agg = {}, ord = [];
    sel[cur].forEach(function (c) { var v = V.filter(function (x) { return x.c === c; })[0] || V[0]; if (!agg[v.id]) { agg[v.id] = 0; ord.push(v.id); } agg[v.id]++; });
    var items = ord.map(function (id) { return { id: id, quantity: agg[id] }; });
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
      .catch(function () { btn.disabled = false; form.submit(); });
  });
  document.querySelectorAll('[data-rg-gopack]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var p = document.querySelector('[data-rg-pack]'); if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  });
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the RG brand cart drawer ===== */
(function () {
  if (window.__rg_atc) return; window.__rg_atc = 1;
  function open() { if (window.RG && window.RG.openCart) return window.RG.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
